import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["config", "children", "disableRenderingForTests", "metricsStartTime", "enableScheduler", "onError", "platformName", "schedulerOptions"];
import { useRef } from 'react';
import { ErrorBoundary } from '../../common/components';
import { useSetupPlatformLogger } from '../hooks/internal';
import { useCreateNavComponentsManager } from '../hooks/internal/useCreateNavComponentsManager';
import { NavigationComponentsContext } from './internal/NavigationComponentsContext';
import { RenderAllNavComponents } from './internal/RenderAllNavComponents';
import { DEFAULT_PLATFORM_NAME } from '../../config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NavigationComponents = _ref => {
  let {
      config,
      children,
      disableRenderingForTests,
      metricsStartTime,
      enableScheduler = false,
      onError,
      platformName = DEFAULT_PLATFORM_NAME,
      schedulerOptions
    } = _ref,
    params = _objectWithoutPropertiesLoose(_ref, _excluded);
  const logger = useSetupPlatformLogger(onError);
  const firstRenderTime = useRef(performance.now()).current;
  const manager = useCreateNavComponentsManager({
    config,
    params: params,
    metricsStartTime: metricsStartTime || firstRenderTime,
    enableScheduler,
    platformName
  });
  return /*#__PURE__*/_jsxs(NavigationComponentsContext.Provider, {
    value: manager,
    children: [children, /*#__PURE__*/_jsx(ErrorBoundary, {
      name: "NavigationComponents",
      logger: logger,
      children: !disableRenderingForTests && /*#__PURE__*/_jsx(RenderAllNavComponents, {
        enableScheduler: enableScheduler,
        schedulerOptions: schedulerOptions
      })
    })]
  });
};